// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".productdownloads__intro{max-width:810px;margin-bottom:2.333rem;display:block}.productdownloads__block:not(:last-child){margin-bottom:4rem}@media (min-width:768px){.productdownloads__block:not(:last-child){margin-bottom:8.667rem}}", ""]);
// Exports
module.exports = exports;
